const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const ORIGIN = 'Webform';
const DEFAULT_CONSENT = 'I want to receive information about new promotions';
const TEXTAREA_LENGTH = 3200;
const MINIMAL_PHONE_LENGTH = 5;
const IFRAME_POST_MESSAGE_FORM_SUBMITTED = 'FORM_SUBMITTED';

export {
  REGEX_EMAIL,
  ORIGIN,
  DEFAULT_CONSENT,
  TEXTAREA_LENGTH,
  MINIMAL_PHONE_LENGTH,
  IFRAME_POST_MESSAGE_FORM_SUBMITTED,
};
